<mat-sidenav-container>
  <mat-sidenav #sidenav="matSidenav" mode="side" opened>
    <img
      class="avatar mat-elevation-z8"
      src="assets/photos/EdFiedler_Photo.PNG"
    />
    <h4 class="name">John Smith</h4>
    <p class="designation">Software Engineer</p>

    <mat-divider></mat-divider>

    <button mat-button class="menu-button" routerLink="/dashboard/home">
      <mat-icon>home</mat-icon>
      <span>Home</span>
    </button>
    <button mat-button class="menu-button" routerLink="/dashboard/profile">
      <mat-icon>person</mat-icon>
      <span>Profile</span>
    </button>
    <button mat-button class="menu-button" routerLink="/dashboard/data-entry">
      <mat-icon>drive_file_move</mat-icon>
      <span>Data Entry</span>
    </button>
    <button mat-button class="menu-button" routerLink="/dashboard/my-tables">
      <mat-icon>table_chart</mat-icon>
      <span>My Tables</span>
    </button>
    <button mat-button class="menu-button" routerLink="/dashboard/about">
      <mat-icon>info</mat-icon>
      <span>About</span>
    </button>
    <button mat-button class="menu-button" routerLink="/dashboard/admin">
      <mat-icon>verified_user</mat-icon>
      <span>Admin</span>
    </button>

    <mat-divider></mat-divider>

    <button mat-button class="menu-button" routerLink="/dashboard/help">
      <mat-icon>help</mat-icon>
      <span>Help</span>
    </button>
  </mat-sidenav>
</mat-sidenav-container>
